export interface Vec2 {
  x: number;
  y: number;
}

export class InputPredictor {
  private correctionTarget: Vec2 | null = null;
  private readonly snapThreshold: number;
  private readonly reconcileThreshold: number;
  private readonly smoothingFactor: number;

  constructor(options?: { snapThreshold?: number; reconcileThreshold?: number; smoothingFactor?: number }) {
    this.snapThreshold = options?.snapThreshold ?? 120;
    this.reconcileThreshold = options?.reconcileThreshold ?? 12;
    this.smoothingFactor = options?.smoothingFactor ?? 0.2;
  }

  reconcile(local: Vec2, authoritative: Vec2): Vec2 {
    const dx = authoritative.x - local.x;
    const dy = authoritative.y - local.y;
    const distance = Math.sqrt(dx * dx + dy * dy);

    if (distance > this.snapThreshold) {
      this.correctionTarget = null;
      return authoritative;
    }

    if (distance > this.reconcileThreshold) {
      this.correctionTarget = authoritative;
    }

    return local;
  }

  apply(local: Vec2): Vec2 {
    if (!this.correctionTarget) {
      return local;
    }

    const dx = this.correctionTarget.x - local.x;
    const dy = this.correctionTarget.y - local.y;
    const distance = Math.sqrt(dx * dx + dy * dy);
    if (distance < 1) {
      this.correctionTarget = null;
      return local;
    }

    return {
      x: local.x + dx * this.smoothingFactor,
      y: local.y + dy * this.smoothingFactor
    };
  }
}
